<template xmlns="http://www.w3.org/1999/html">

    <div class="container-fluid px-0">

        <div class="header-show-image header-client-model-show-image-parallax"
             :class="{'d-none' : modelForm.models.length > 0}">
            <div class="header-title-block d-flex mx-auto flex-column">
                <h1 class="text-start text-md-center mb-md-5">
                    {{  lang === 'ar-sa' ? 'اطبع نموذجك ثلاثي الأبعاد' : 'Print your 3D model' }}

                </h1>
                <p class="text-start text-md-center">

                    {{  lang === 'ar-sa' ? 'ارفع نموذجك الثلاثي الأبعاد واحصل على عرض سعر فوري. سيعمل فريقنا المختص على تحسين كل التفاصيل لتتطابق مع رؤيتك. استفد الان من خبراتنا المتخصصة في الطباعة ثلاثية الأبعاد وخدمات التسليم السريعة لجعل أفكار منتجاتك حقيقية. يتم طباعة النموذج الخاص بك وتسليمه إليك خلال 10 أيام أو أقل.'
                     :
                    'Upload your model and get an instant quote, our team will refine every detail to match your vision. Keep in mind that creating a 3D model takes up to 15 days, but the results are worth it.'
                    }}
                </p>

                <div class="mb-5 mb-md-0 d-flex flex-column flex-md-row mx-md-auto btn__block btn__block_request">
                    <a href="#upload-files" class="btn  mb-4 mb-md-0 text-decoration-none btn-light-purple btn__block__btn me-md-3">

                        {{ lang === 'ar-sa' ? 'زر: تحميل النموذج ثلاثي الأبعاد' : 'Upload 3D Model' }}
                    </a>
                    <a href="/contact-us" class=" ms-md-3 btn text-decoration-none btn-light-purple btn__block__btn_second">

                        {{ lang === 'ar-sa' ? 'تواصل معنا للمساعدة' : 'Contact Us' }}
                    </a>
                </div>
            </div>
        </div>

        <div class="row justify-content-center request-3d-print-block">
            <div class="col-md-12 px-0 mx-0 ">
<!--                <ul class="d-flex breadcrumb-list">-->
<!--                    <li class="breadcrumb-item"><a href="/" class="text-decoration-none">{{ breadCrumbs.home }} </a>-->
<!--                    </li>-->
<!--                    <li class="breadcrumb-item active">{{ breadCrumbs.active }}</li>-->
<!--                </ul>-->

                <div class="create-client-model-block">
                    <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>

                    <div class="position-relative">
                        <div class="d-flex d-md-block justify-content-center">
                            <h1 class="ms-0 me-md-5 "
                                :class="{'d-none' : modelForm.models.length === 0}">{{ titlesUpload.main }}</h1>
                        </div>
                        <div v-if="modelForm.models.length > 0"
                                class="mb-5">
                            <DropFileComponent :modelForm="modelForm"
                                               :dataToCreateClientModel="dataToCreateClientModel"
                                               :files1="files1" :copyDataLength="copyDataLength"
                                               :show="'img'"/>

                        </div>
                        <div class="wrapper-client-model position-relative justify-content-between  mx-auto d-flex flex-row"
                             :class="{'d-none': modelForm.step !== index, 'd-block': modelForm.step === 0}"
                             v-for="(elemToCalculate,index) in modelForm.models">
                            <div class="print-data-block col-5">
                                <div class="details position-relative">
                                    <!--                                        pagination-->
<!--                                    <div v-if="window.currentLang == 'en'">-->
                                        <div class="pagination-arrow pagination-prev d-md-flex change-data "
                                             :class="{'disabled' : index === 0 || modelForm.models.length === 0, 'ar-sa-pagination-prev' : window.currentLang == 'ar-sa'}"
                                             data-type="en-prev"
                                             v-if="modelForm.models.length > 1">
                                            <a type="submit" @click="modelForm.step--"
                                               class="btn-arrow "
                                               :class="{'disabled' : index === 0}"><img src="/images/icons/arrow/right-arrow.svg"
                                                                                        alt="Prev"></a>
                                        </div>
                                    <!--                                        end pagination-->
                                    <div class="details-content">
                                        <p class="model-file-name text-center"> {{ titlesOptions.nameFile }} - {{
                                                elemToCalculate.file.name
                                            }}</p>

                                        <div v-if="!elemToCalculate.filePath"
                                            class="d-flex settings-switch justify-content-between">
                                            <p class="col-6" :class="{ active: hideAdvancePrintOptions }" @click="hideAdvancePrintOptions = true">{{ lang === 'ar-sa' ? 'إعدادات افتراضية' : 'Default Settings' }}</p>
                                            <p class="col-6" :class="{ active: !hideAdvancePrintOptions }" @click="hideAdvancePrintOptions = false">{{ lang === 'ar-sa' ? 'إعدادات متقدمة' : 'Advanced Settings' }}</p>
                                        </div>

                                        <label v-if="elemToCalculate.price && elemToCalculate.price != 0" class="price-client-model d-flex justify-content-between">
                                            <span>{{ titlesOptions.price }}</span>
                                            <span class="client-model-price">~{{ elemToCalculate.price }}{{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }}</span> </label>
                                        <label v-if="elemToCalculate.price && elemToCalculate.price == 0" class="price-client-model">
                                            <span class="cura-error-notify">Sorry,error in calculation price
                                            </span>
                                            <br>
                                            <span class="cura-error-notify">We calculatete this model manualy
                                            </span>
                                            <br>
                                            <span class="cura-error-notify">
                                                And notify you by results
                                            </span>
                                        </label>

                                        <label v-if="elemToCalculate.materialName"
                                               class="d-flex align-items-center justify-content-between">
                                            <span>Material </span>
                                            <span> {{ elemToCalculate.materialName.label }}</span></label>
                                        <label v-if="elemToCalculate.infill_percentage"
                                               class=" d-flex align-items-center justify-content-between">
                                            <span>Infill </span>
                                            <span> {{ elemToCalculate.infill_percentage * 20 }} %</span></label>
                                        <label v-if="elemToCalculate.resolution"
                                               class=" d-flex align-items-center mb-5 justify-content-between">
                                            <span>Layer height</span>
                                            <span> {{ elemToCalculate.resolution / 10 }} mm</span></label>
                                        <hr class="mb-5">
                                        <div class="select-colors position-relative input__block">
                                            <div v-if="elemToCalculate.price"
                                                 class="dropdown my-4 col-12 col-md-6 js-dropdown-colors dropdown-colors">
                                                <label>{{ titlesOptions.chooseColor }} : </label>
                                                <a class="dropdown-toggle px-0 text-decoration-none   js-dropdown navigation-footer"
                                                   href="#" role="button"
                                                   data-bs-toggle="dropdown"
                                                   @click="showColorsList(elemToCalculate)"
                                                   aria-expanded="false">
                                                </a>

                                                <ul class="dropdown-menu dropdown-menu-colors d-grid js-dropdown-list"
                                                    :class="{'d-none': !showColors}">
                                                    <li v-for="color in elemToCalculate.colors"
                                                        v-model="elemToCalculate.color"
                                                        class="choose-color"
                                                        :style="{'background-color': color}"
                                                        @click="changeColors($event,index,elemToCalculate,color)">
                                                    </li>
                                                </ul>
                                            </div>

                                            <span class="text-danger error colors_error"></span>
                                        </div>
                                        <a v-if="elemToCalculate.filePath"
                                            class="settings-toggle d-flex align-items-center"
                                           @click="toggleSettings()"
                                            :class="{'active' : settingsOpen}">
                                             {{  lang === 'ar-sa' ? 'قم بتغيير الإعدادات ' : 'Edit the settings' }}
                                        </a>

                                        <form v-if="settingsOpen || !elemToCalculate.filePath"
                                            action="#" method="post" :id="'uploadForm-' + index">
                                            <div class="select-material position-relative input__block">
                                                <label>{{ titlesOptions.titleMaterial }}</label>
                                                <span style="color: red; font-size:15px;">*</span>
                                                <v-select :options="materials"
                                                          @input="getColorsAndSetFirstAsSelected(elemToCalculate)"
                                                          v-model="elemToCalculate.material"
                                                          :clearable="false"
                                                          :placeholder="titlesOptions.chooseMaterial" class="input">
<!--&lt;!&ndash;                                                    <template #open-indicator="{ attributes }" #val>&ndash;&gt;-->
<!--                                                    <span v-bind="attributes">-->
<!--                                                        <img class="select-img  position-fixed"-->
<!--                                                             src="/images/icons/vector.png" alt="v"/>-->
<!--                                                    </span>-->
<!--                                                    </template>-->
                                                </v-select>
                                                <span class="text-danger error material_id_error"></span>
                                            </div>
                                            <div class="main-options d-flex mt-4 input__block position-relative">
<!--                                                <h4 v-if="!hideAdvancePrintOptions">{{ titlesOptions.advance }}</h4>-->
<!--                                                <h4 v-else>{{ titlesOptions.simplified }}</h4>-->
<!--                                                <i class="fa-regular ms-2 fs-4 text-danger fa-circle-question"-->
<!--                                                   v-if="hideAdvancePrintOptions"-->
<!--                                                   @mouseover="active = !active"-->
<!--                                                   @mouseleave="active = !active"-->
<!--                                                ></i>-->
<!--                                                <i class="fa-regular ms-4 fa-square-minus"-->
<!--                                                   @click="hideAdvancePrintOptions = !hideAdvancePrintOptions"-->
<!--                                                   :class="{'fa-square-plus ': hideAdvancePrintOptions}"></i>-->
                                                <div class="position-absolute default-simplified" v-if="active">
                                                    <p class="fs-5 mb-0">
                                                        {{ titles.default }}:
                                                    </p>
                                                    <p class="fs-5 mb-0">
                                                        {{ titlesOptions.layerHeight }}: 0.15mm
                                                    </p>
                                                    <p class="fs-5 mb-0">
                                                        {{ titlesOptions.infillPercentage }}: 20 %
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="additional-options" v-if="!hideAdvancePrintOptions || settingsOpen">
                                                <div class="position-relative  input__block">
                                                    <label>{{ titlesOptions.layerHeight }}</label>
                                                    <v-select :options="resolutions"
                                                              :placeholder="elemToCalculate.resolution ? elemToCalculate.resolution / 10 + 'mm' : 'Choose layer height'"
                                                              :clearable="false"
                                                              v-model="elemToCalculate.height"
                                                              @input="hideBtn"
                                                              class="input">
<!--                                                        <template #open-indicator="{ attributes }" #val>-->
<!--                                                    <span v-bind="attributes">-->
<!--                                                        <img class="select-img   position-fixed"-->
<!--                                                             src="/images/icons/vector.png" alt="v"/>-->
<!--                                                    </span>-->
<!--                                                        </template>-->
                                                    </v-select>
                                                    <span class="text-danger error resolution_error"></span>
                                                </div>

                                                <div class="position-relative  input__block">
                                                    <label>{{ titlesOptions.infillPercentage }}</label>
                                                    <v-select :options="infillPercentage"
                                                              @input="hideBtn"
                                                              v-model="elemToCalculate.percentage"
                                                              :clearable="false"
                                                              :placeholder="elemToCalculate.infill_percentage ? elemToCalculate.infill_percentage * 20 + '%' : 'Choose infill percentage'"
                                                              class="input">
<!--                                                        <template #open-indicator="{ attributes }" #val>-->
<!--                                                    <span v-bind="attributes">-->
<!--                                                        <img class="select-img   position-fixed"-->
<!--                                                             src="/images/icons/vector.png" alt="v"/>-->
<!--                                                    </span>-->
<!--                                                        </template>-->
                                                    </v-select>
                                                    <span class="text-danger error infill_percentage_error"></span>
                                                </div>
                                            </div>
                                        </form>
                                        <div class="wrapper-actions row mt-5">
                                            <div class="col-12 custom-model-buttons d-flex justify-content-between flex-column mb-5 flex-xxl-row">
                                                <!--                                        add to cart-->
                                                <a v-show="elemToCalculate.filePath"
                                                   type="submit" @click="addModelToClientCart(elemToCalculate)"
                                                   class="btn btn-purple col-xxl-6 me-xxl-3  mb-3 mb-xxl-0 m-0"
                                                   :class="{'disabled' : (!(elemToCalculate.price) || elemToCalculate.price == 0) }">{{
                                                        titlesOptions.addThisModeltoCart
                                                    }}</a>
                                                <!--                                       end add to cart-->
                                                <!--                                        find price-->
                                                <a type="button"
                                                   :class="{
                                                      'disabled': !elemToCalculate.material,
                                                      'w-100': !elemToCalculate.filePath
                                                    }"

                                                   @click="getModelPrice(elemToCalculate, index)"
                                                   class="btn btn-purple col-xxl-6 ms-xxl-3 mb-4 mb-md-0 m-0"
                                                >
                                                    {{ titlesOptions.calculateModelPrice }}
                                                </a>
                                                <!--                                       end find price-->
                                            </div>
                                            <div class="col-12 d-flex justify-content-end custom-model-actions "
                                                 @click="removeModel(index)">

                                                <p>{{ lang === 'ar-sa' ? 'حذف النموذج' : 'Remove Model' }}</p>
                                                <i class="fa-regular ms-4 fa-trash-can delete-button"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <!--                                        pagination-->
<!--                                    <div v-if="window.currentLang == 'en'">-->
                                        <div class="pagination-arrow pagination-next d-md-flex change-data "
                                             :class="{'disabled': elemToCalculate.price === '' || index === modelForm.models.length-1, 'ar-sa-pagination-next' : window.currentLang == 'ar-sa'}"
                                             v-if="modelForm.models.length > 1">

                                            <a type="submit" @click="modelForm.step++"
                                               class="btn-arrow " data-type="en-next">
                                                <img src="/images/icons/arrow/right-arrow.svg" alt="Next"></a>
                                        </div>
                                    <!--                                        end pagination-->
                                </div>
                                <div class="wrapper-pagination-numbers my-4">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="wrapper-pagination-item"
                                             v-for="(elemToCalculate,localIndex) in modelForm.models"
                                             @click="modelForm.step = localIndex"
                                             :key="localIndex"
                                             :class="{'active' : localIndex === modelForm.step}">
                                            <div class="pagination-item"
                                                 :class="{'active' : localIndex === modelForm.step}">
                                                {{ localIndex + 1 }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div
                                 class="d-flex justify-content-center model-preview-block">
                                <Model3DPreviewComponent
                                    :model-color="elemToCalculate.color"
                                    :model-obj-path="elemToCalculate.filePath"
                                    :unique-indeficator="elemToCalculate.uniqueIndeficator || defaultValue"
                                >
                                </Model3DPreviewComponent>
                            </div>

                        </div>

                        <div class="d-flex flex-column upload-files"
                             id="upload-files"
                             :class="{'d-none' : modelForm.models.length > 0}">
                            <div class=" mb-5 mb-md-0 upload-model">
                                <div class="block">
                                    <div class="pb-0 upload-file-block">
                                        <div class="upload-file pb-0">
                                            <h2>{{ titlesUpload.header }}</h2>
                                            <div class="d-flex flex-column">
                                                <p>{{ titlesUpload.drag }}</p>
                                                <DropFileComponent :modelForm="modelForm"
                                                                   :dataToCreateClientModel="dataToCreateClientModel"
                                                                   :files1="files1" :copyDataLength="copyDataLength"
                                                                   :show="'purple'"/>
                                            </div>
                                        </div>
                                    </div>
<!--                                    <div class="d-flex flex-column flex-lg-row justify-content-between pt-0">-->
<!--                                        <div class="link-on-gallery col-lg-6 d-flex flex-column">-->
<!--                                            <h3>{{ titlesUpload.chooseModel }}</h3>-->
<!--                                            <a href="/gallery"-->
<!--                                               class="btn-purple px-3 btn">{{ titlesUpload.chooseModelBtn }}</a>-->
<!--                                        </div>-->
<!--                                        <div class="email-us  col-lg-6 d-flex flex-column">-->
<!--                                            <h3>{{ titlesUpload.design }}</h3>-->
<!--                                            <a href="/question" class="btn-purple btn">{{ titlesUpload.contactUs }}</a>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>
                            </div>
<!--                            <div class="col-md-6 pe-0 details-model">-->
<!--                                <div class="preload-info d-flex align-items-center">-->
<!--                                    <h2>{{ titlesUpload.asideText }}</h2>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">

import TheLoaderComponent from "./TheLoaderComponent";
import DropFileComponent from "./DropFileComponent";
import Model3DPreviewComponent from "./Model3DPreviewComponent";
import * as THREE from "three";
import {OrbitControls} from "three/addons/controls/OrbitControls";
import {GLTFLoader} from "three/addons/loaders/GLTFLoader";

export default {
    components: {
        TheLoaderComponent,
        DropFileComponent,
        Model3DPreviewComponent,
    },
    props: ['env'],
    data() {
        return {
            settingsOpen: false,
            defaultValue: 123,
            showColors: false,
            active: false,
            hideAdvancePrintOptions: true,
            showLoader: false,
            files1: [],
            modelFiles: null,
            materials: [],
            resolutions: [
                {val: 0.1, label: '0.15 mm'},
                {val: 0.2, label: '0.2 mm'},
                {val: 0.3, label: '0.3 mm'},
            ],
            infillPercentage: [
                {val: 20, label: '20 %'},
                {val: 40, label: '40 %'},
                {val: 60, label: '60 %'},
                {val: 80, label: '80 %'},
            ],
            colors: [],
            selected: null,
            dataModel: [],
            color: '',
            material: '',
            infill_percentage: '',
            resolution: null,
            price: [],
            copyDataLength: 1,
            purpleFile: null,
            dataClientModel: [],
            arrayObjModelToCart: [],
            dataToCreateClientModel: [],
            calculateDataFromServer: [],
            lang: window.currentLang,
            modelForm: {
                sendable: false,
                step: 0,
                models: [],
            },
            titlesUpload: {
                main: '',
                header: '',
                drag: '',
                upload: '',
                chooseModel: '',
                chooseModelBtn: '',
                design: '',
                contactUs: '',
                asideText: ''
            },
            titlesOptions: {
                nameFile: '',
                price: '',
                titleMaterial: '',
                chooseMaterial: '',
                titleColor: '',
                chooseColor: '',
                simplified: '',
                advance: '',
                layerHeight: '',
                chooseLayerHeight: '',
                resolution: '',
                infillPercentage: '',
                chooseInfillPercentage: '',
                findPrice: '',
                addToCart: '',
                addThisToCart: '',

            },
            breadCrumbs: {
                home: '',
                active: ''
            },
            titles: {
                next: '',
                prev: '',
                default: ''
            },
        }
    },
    created() {
        document.addEventListener('click', this.closeMenu);
    },
    mounted() {
        this.getMaterials()
        this.clearErrorInout()
        this.addSocketListner()
        this.checkIsCalculatedModlesOnServer()
    },
    updated() {
        let inputs = document.querySelectorAll('.input')
        let blockColors = document.querySelector('.select-colors')
        let optionsColorList = blockColors && blockColors.querySelector('.v-select ul')
        let details = document.querySelectorAll('.details')
        let optionsColors = optionsColorList && optionsColorList.querySelectorAll('.vs__dropdown-option')
        let liLang = document.querySelectorAll('.js-change-lang li')

        optionsColors && optionsColors.forEach(option => {
            option.style.backgroundColor = option.textContent
            option.style.color = 'transparent';
        })
        inputs.forEach((input) => {
            input && input.addEventListener('click', this.setSelectedColorToBackground)
        })

        // if (details.length === 1) {
        //     details[0].classList.remove('d-none')
        // }

        this.changeContent()
        window.autoNotifyResultsInHeader()

    },
    methods: {
        toggleSettings() {
            this.settingsOpen = !this.settingsOpen
        },
        showColorsList(elemToCalculate) {
            let vm = this
            if (!elemToCalculate.colors) {
                elemToCalculate.colors = vm.materials[elemToCalculate.material_id - 1].colors
            }
            vm.showColors = !vm.showColors

        },
        addSocketListner() {
            // create listner of socket channel to refresh page if we have calculated data to this user
            let vm = this;
            //in app.js window.sub is created
            window.sub.on('publication', function (ctx) {
                    if (ctx.data.refresh_data) {
                        // here axios to endpoint with cura results and refresh component data
                        vm.checkIsCalculatedModlesOnServer();
                    }
                }
            )
        },

        refreshCalculatingModelsList() {
            let vm = this;
            if (vm.modelForm.models.length > 0) {
                // TODO !! component data mutation
                vm.modelForm.models.forEach(item => {
                    // showing lists of print params
                    vm.hideAdcancePrintOptions = false;

                });
                //here need add functionality to update modeForm if user don`t leave download page
            }
            vm.modelForm.models = vm.calculateDataFromServer;
        },
        checkIsCalculatedModlesOnServer() {
            let vm = this;
            vm.calculateDataFromServer = [];
            // i think better way tottaly replace vm.modelForm.models
            axios.get('/cura_results').then(function (response) {
                    let data = response.data;

                    data.forEach(item => {
                        let result = {}
                        result.price = item['price'];
                        //for testing
                        result.printTime = item['print_time'];
                        result.materialWeight = item['print_weight'];
                        result.printCost = item['print_cost'];
                        result.materialCost = item['material_cost'];
                        result.printFailCost = item['print_fail_cost'];
                        result.operationCost = item['operation_cost'];
                        result.packaging = item['packaging'];
                        result.vatCost = item['vot_cost'];
                        result.subTotal = item['sub_total'];
                        result.file = {};
                        result.file.name = item['file'];
                        result.resultId = item['id'];
                        result.material_id = item['material'];
                        result.resolution = item['height'];
                        result.infill_percentage = item['infill'];
                        result.filePath = "/storage/models_gltf/" + item['file_hash'] + '_' + item['file_size'] + '.gltf';
                        result.fileHash = item['file_hash'];
                        result.fileSize = item['file_size'];
                        result.uniqueIndeficator = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
                        result.materialName = vm.materials[result.material_id - 1]

                        if (vm.materials.length > 0) {
                            result.colors = vm.materials[result.material_id - 1].colors
                            result.color = result.colors[0];
                        }

                        vm.calculateDataFromServer.push(result)
                    });
                }
            ).catch(function () {
                window.notify('Sorry, error on server.', 'error')
            })
            this.refreshCalculatingModelsList();
        },

        closeMenu(event) {
            if (this.showColors && !event.target.classList.contains("js-dropdown")) {
                if (!event.target.classList.contains("choose-color") || !event.target.classList.contains("js-dropdown-list")) {
                    this.showColors = false;
                }
            }
        }
        ,
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                this.breadCrumbs.home = 'الرئيسية'
                this.breadCrumbs.active = 'طلب طباعة ثلاثية الأبعاد '
                this.titlesUpload.main = 'طلب طباعة ثلاثية الأبعاد '
                this.titlesUpload.header = 'ارفع نموذج الطباعة وراح تجيك تسعيرة فورية'
                this.titlesUpload.drag = 'ستكون خيارات التخصيص متاحة بعد تحميل ملف النموذج'
                this.titlesUpload.upload = 'رفع الملفات'
                this.titlesUpload.chooseModel = 'ماعندك نموذج ثلاثي الأبعاد؟'
                this.titlesUpload.chooseModelBtn = 'اكتشف معرض النماذج والمنتجات'
                this.titlesUpload.design = 'عندك مشروع أو فكرة وتبي تشوفها على الحقيقة؟'
                this.titlesUpload.contactUs = 'تواصل معنا'
                this.titlesUpload.asideText = 'خيارات الطباعة بتكون متاحة بعد رفع  النموذج الطباعة'
                this.titlesOptions.nameFile = 'ملف '
                this.titlesOptions.price = 'السعر'
                this.titlesOptions.titleMaterial = 'المواد'
                this.titlesOptions.chooseMaterial = 'اختر المواد'
                this.titlesOptions.titleColor = 'اللون'
                this.titlesOptions.chooseColor = 'اختر اللون'
                this.titlesOptions.simplified = 'وضع الطباعة  المبسط'
                this.titlesOptions.advance = 'وضع الطباعة المتقدم'
                this.titlesOptions.layerHeight = 'دقة الطباعة'
                this.titlesOptions.chooseLayerHeight = 'اختر دقة الطباعة'
                this.titlesOptions.resolution = 'اختر'
                this.titlesOptions.infillPercentage = 'كثافة الحشوة'
                this.titlesOptions.chooseInfillPercentage = 'اختر كثافة الحشوة'
                this.titlesOptions.calculateModelPrice = 'تسعير النموذج'
                this.titlesOptions.addThisModeltoCart = 'اضف النموذج إلى السلة'
                this.titlesOptions.findPrice = 'إرسال'
                this.titlesOptions.addToCart = 'أضف إلى السلة'
                this.titles.next = 'التالي'
                this.titles.prev = 'السابق'
                this.titles.default = 'الافتراضي'
            } else {
                this.lang = 'en'
                this.titles.default = 'Default'
                this.titles.next = 'Next'
                this.titles.prev = 'Previous'
                this.titlesOptions.nameFile = 'Model file'
                this.titlesOptions.price = 'Price'
                this.titlesOptions.titleMaterial = 'Material'
                this.titlesOptions.chooseMaterial = 'Choose material'
                this.titlesOptions.titleColor = 'Color'
                this.titlesOptions.chooseColor = 'Choose color'
                this.titlesOptions.simplified = 'Simplified mode'
                this.titlesOptions.advance = 'Advance mode'
                this.titlesOptions.layerHeight = 'Layer height'
                this.titlesOptions.resolution = 'Choose resolution'
                this.titlesOptions.infillPercentage = 'Infill percentage'
                this.titlesOptions.findPrice = 'Find Out the price'
                this.titlesOptions.addToCart = 'Add to cart'
                this.titlesOptions.addThisToCart = 'Add this element to cart'
                this.titlesOptions.addThisModeltoCart = 'Add Model to Cart'
                this.titlesOptions.calculateModelPrice = 'Calculate Model Price'
                this.breadCrumbs.home = 'Home'
                this.breadCrumbs.active = 'Request 3D print'
                this.titlesUpload.main = 'Request 3D print'
                this.titlesUpload.header = 'Upload your model for an instant quote'
                this.titlesUpload.drag = 'Customization options will be available after a model file is loaded'
                this.titlesUpload.upload = 'Upload 3D model'
                this.titlesUpload.chooseModel = 'Don’t have a 3D model?'
                this.titlesUpload.chooseModelBtn = 'Browse our 3D Gallery now'
                this.titlesUpload.design = 'Do you have a product or design idea to be 3d printed?'
                this.titlesUpload.contactUs = 'Contact us'
                this.titlesUpload.asideText = 'Customization options will be available after a model file is loaded'
            }
        }
        ,
        hideBtn() {
            let btn = document.querySelectorAll('.change-data')
            btn.forEach(item => {
                item.classList.add('d-none')
            })
        }
        ,
        nextDataModel(n) {
            n.active = true;
        }
        ,
        prevDataModel(event, n, index) {
            let detailBlocks = document.querySelector(`.detail__block-${index}`)
            let previusSibling = detailBlocks.previousElementSibling;
            detailBlocks && detailBlocks.classList.add('d-none')
            previusSibling && previusSibling.classList.remove('d-none')

            let btnChangeData = document.querySelectorAll('.change-data')
            btnChangeData.forEach(item => {
                item.classList.add('d-none')
            })
        }
        ,
        setSelectedColorToBackground() {
            let blockColors = document.querySelectorAll('.select-colors')
            blockColors.forEach(item => {
                setTimeout(() => {
                    let optionsColorList = item && item.querySelector('.v-select ul')
                    let optionsColors = optionsColorList && optionsColorList.querySelectorAll('.vs__dropdown-option')
                    optionsColors && optionsColors.forEach((option) => {
                        option.style.backgroundColor = option.textContent
                        option.style.color = 'transparent';
                    })
                }, 300)
            })

        }
        ,
        getMaterials() {
            let vm = this;
            vm.showLoader = true
            axios.get('/materials').then(function (response) {
                let materials = response.data.data

                vm.showLoader = false
                materials.forEach(item => {
                    let objMaterials = {}

                    objMaterials.value = item.id
                    objMaterials.label = item.name
                    objMaterials.colors = item.colors

                    vm.materials.push(objMaterials)
                })
            })
        }
        ,
        getColorsAndSetFirstAsSelected(elemToCalculate) {
            this.colors = elemToCalculate.material.colors;
            elemToCalculate.color = elemToCalculate.material.colors[0];
        }
        ,
        clearErrorInout() {
            let inputs = document.querySelectorAll('.input')
            inputs.forEach(input => {
                input.addEventListener('input', e => {
                    let parent = e.target.closest('div')
                    let child = parent.querySelector('.error')
                    child && (child.innerHTML = '')
                })
            })
        }
        ,

        addModelToClientCart(elemToCalculate) {
            let vm = this

            vm.showLoader = true
            let modelsToCart = [];

            let item = elemToCalculate;
            if (!item.color) {
                item.color = vm.materials[item.material_id - 1].colors[0]
            }
            item.file_path = elemToCalculate.filePath;

            item.file_hash = elemToCalculate.fileHash;
            item.file_size = elemToCalculate.fileSize;
            item.name = item.file['name'];
            item.file_name = item.name;
            modelsToCart.push(elemToCalculate)

            let data = {
                'models_data': modelsToCart,
            }

            axios.post('/client-model/cart', data, {}).then(function (response) {
                vm.showLoader = false
                let datas = response.data.data
                // let showModel = true
                datas.forEach(data => {
                    let arr = []
                    let objModelInfo = {
                        id: data.id,
                        // img: data.path,
                        price: data.price,
                        priceCalculate: data.price,
                        count: 1,
                        name: data.name,
                        type: data.type,
                        typeCreate: true,
                        color: data.color,
                        material: data.material.name,
                        layerHeight: data.layer_height,
                        infillPercentage: data.infill_percentage,
                        file_hash: data.file_hash,
                        file_size: data.file_size,
                        img: '/storage/models_static_gif/' + data.file_hash + '_' + data.file_size + '_' + data.color.replace('#', '') + '.gif',
                        dynamic_img: '/storage/models_dynamic_mp4/' + data.file_hash + '_' + data.file_size + '_' + data.color.replace('#', '') + '.mp4',
                        dynamic_img_ready: false,
                        mouseover: false,

                    }

                    if (JSON.parse(localStorage.getItem(`cart-client-${userId}`))) {
                        arr = JSON.parse(localStorage.getItem(`cart-client-${userId}`))
                    }

                    let flagInCartSelectedColor = false
                    arr.forEach((productInCart) => {
                        if (productInCart.id === objModelInfo.id
                            && productInCart.color === objModelInfo.color
                            && productInCart.price === objModelInfo.price
                            && productInCart.name === objModelInfo.name
                            && productInCart.fileHash === objModelInfo.fileHash
                            && productInCart.fileSize === objModelInfo.fileSize
                            && productInCart.material === objModelInfo.material
                            && productInCart.infillPercentage === objModelInfo.infillPercentage
                            && productInCart.layerHeight === objModelInfo.layerHeight
                            && productInCart.type === objModelInfo.type
                        ) {
                            productInCart.count += 1;
                            flagInCartSelectedColor = true;
                        }
                    });
                    if (!flagInCartSelectedColor) {
                        arr.push(objModelInfo)
                    }


                    localStorage.setItem(`cart-client-${userId}`, JSON.stringify(arr));
                })

                window.notify('Model  added to cart', 'success')
                updateCartCount();
            }).catch(function (error) {
                vm.showLoader = false
                vm.errorClientModel(error)
                window.notify('Model not added to cart', 'error')
            })
        }
        ,
        changeColors(event, index, elemToCalculate, choosenColor) {
            let vm = this
            let parent = event.target.closest('.js-dropdown-colors')
            let showColor = parent.querySelector('.js-dropdown ')
            showColor.style.background = ''

            showColor.style.background = choosenColor
            elemToCalculate.color = choosenColor
            vm.showColors = false
        }
        ,

        getModelPrice(elemToCalculate, index) {
            let vm = this
            const data = new FormData()
            vm.showLoader = true
            data.delete('model')
            data.append('color', elemToCalculate.color)

            data.append('material_id', +elemToCalculate.material.value)
            if (elemToCalculate.height) {
                data.append('resolution', +elemToCalculate.height.val)
            } else {
                data.append('resolution', 0.1)
            }
            if (elemToCalculate.percentage) {
                data.append('infill_percentage', +elemToCalculate.percentage.val)
            } else {
                data.append('infill_percentage', 20)
            }

            // if model already have price send only file name (not file)
            if (elemToCalculate.price) {
                data.append('file_name', elemToCalculate.file.name)
                data.append('file_hash', elemToCalculate.fileHash)
                data.append('file_size', elemToCalculate.fileSize)

            } else {
                data.append('model', elemToCalculate.file)
            }

            let formDataObject = {};
            for (let [key, value] of data.entries()) {
                formDataObject[key] = value;
            }


            //remove cathc to async working
            if (elemToCalculate.filePath) {
                let indexToRemove = vm.modelForm.models.findIndex(model => model.resultId === elemToCalculate.resultId);
                axios.post('/client-model/calculate', data).then(function (response) {
                })
                vm.removeModel(indexToRemove);

            } else {
                axios.post('/client-model/calculate', data).then(function (response) {
                })
            }


            let infoText;
            if (localStorage.getItem('lang') === 'ar-sa') {
                infoText = "تمت إضافة النماذج للتسعير بنجاح. سوف يتم إرسال معلومات التسعير إلى بريدك الإلكتروني حين جاهزيتها"
            } else {
                infoText = 'The model added to the calculation. When the results are ready, we will send the information to your email.'
            }
            window.notifyDontClosing(infoText, 'success')
            vm.showLoader = false;
        },

        removeModel(index) {
            let resultId = this.modelForm.models[index].resultId;
            let data = {};
            data.resultId = resultId;
            axios.post('/cura_results', data).then(function (response) {
                if (localStorage.getItem('lang') === 'ar-sa') {
                    response && window.notify('تم إنشاء الطلب')
                } else {
                    response && window.notifyDontClosing('Model removed', 'info')
                }
            }).catch(function (error) {
                if (localStorage.getItem('lang') === 'ar-sa') {
                    // window.notify('لم يتم إنشاء الطلب', 'error')
                } else {
                    window.notify('Server error', 'error')
                }
            })
            window.autoNotifyResultsInHeader();
            this.modelForm.models.splice(index, 1);
            if (this.modelForm.step === index) {
                this.modelForm.step = 0
            }
            // if(this.modelForm.models.length>0){
            //     location.reload();
            // }
        },

        errorClientModel(error) {
            function createErrorItem(error, selectName, name) {
                let errorSelect = document.querySelector(selectName)
                name && (errorSelect.innerHTML = name[0])
            }

            createErrorItem(error, '.colors_error', error.response.data.errors.color)
            createErrorItem(error, '.infill_percentage_error', error.response.data.errors.infill_percentage)
            createErrorItem(error, '.material_id_error', error.response.data.errors.material_id)
            createErrorItem(error, '.model_error', error.response.data.errors.model)
            createErrorItem(error, '.resolution_error', error.response.data.errors.resolution)
        }
    },

    beforeDestroy() {
        // remove event listener when component is destroyed
        document.removeEventListener('click', this.closeMenu);
    },
}
</script>

<style lang="scss">
@import "../../sass/front/client-model";
.cura-error-notify{
    color: #E10000;
}
.pagination-arrow {
    .btn-arrow {
        width: 48px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 100%;
        }

        &:hover {
            background: rgb(234 232 237 / 97%);
        }
    }

    &.disabled {
        pointer-events: none;
        cursor: not-allowed;
        opacity: 0.5;
    }

    &.pagination-prev {
        position: absolute;
        bottom: -20%;
        z-index: 1;
        left: -10%;
        img {
            transform: rotate(180deg);
        }
        &.ar-sa-pagination-prev {
            left: unset;
            right: -10%;
            img {
                transform: rotate(0deg);
            }
        }
    }

    &.pagination-next {
        position: absolute;
        bottom: -20%;
        z-index: 1;
        right: -10%;
        &.ar-sa-pagination-next {
            right: unset;
            left: -10%;
            img {
                transform: rotate(180deg);
            }
        }
    }
}

.wrapper-pagination-numbers {
    .wrapper-pagination-item {
        padding: 0 15px;
        width: 33px;
        height: 33px;
        max-width: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &.active {
            padding: 0;
        }

        &:hover {
            background: rgb(234 232 237 / 97%);
            border-radius: 50%;
            //padding: 15px;
            //max-width: 33px;
            //max-height: 33px;
            //width: 100%;
            //height: auto;
            //display: flex;
            //justify-content: center;
            //align-items: center;
        }

        .pagination-item {
            font-style: normal;
            font-weight: 400;
            font-size: 1.4rem;
            line-height: 2.4rem;
            color: #3E3E3E;

            &.active {
                background: #F5F1FF;
                border-radius: 50%;
                padding: 15px;
                max-width: 33px;
                max-height: 33px;
                width: 100%;
                height: auto;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}

.wrapper-client-model {
    justify-content: space-evenly;
}

.model-preview-block {
    width: fit-content;
    padding-left: 5px;
    padding-bottom: 5px;
    height: fit-content;
    border-radius: 30px;
    border: 1px solid var(--fill-color-light-purple-darker, #E2D8FF);
    background: var(--fill-color-white, #FFF);
}
@media screen and (max-width: 1600px) {
    .model-preview-block {
        width: 600px;
    }
}

@media (min-width: 1200px) and (max-width: 1500px) {
    .wrapper-client-model {
        justify-content: space-around;
    }
}

@media screen and (max-width: 1200px) {
    .print-data-block {
        margin: auto;
        width: 80%;
    }
    .wrapper-client-model {
        flex-direction: column !important;
    }
    .model-preview-block {
        margin: auto;
    }
}


@media screen and (max-width: 567px) {
    .model-preview-block {
        justify-content: space-between !important;
        margin: 0;
    }
    .print-data-block {
        width: 70%;
    }
    .pagination-arrow.pagination-next {
        position: absolute;
        top: 50%;
        z-index: 1;
        right: -20%;
    }

    .pagination-arrow.pagination-prev {
        position: absolute;
        top: 50%;
        z-index: 1;
        left: -20%;
    }

}
</style>
